import ons from "onsenui";
import * as React from "react";
import { getCSSIOSSuffix } from "../utils/DeviceUtils";

interface BackButtonProps {
  onClick: () => void;
  isBlack?: boolean;
}

export function BackButton(props: BackButtonProps): JSX.Element {
  return (
    <div
      className={
        "BackButton__root" +
        (ons.platform.isIOS() ? ` BackButton__root_iOS${getCSSIOSSuffix()}` : "")
      }
      onClick={props.onClick}
    />
  );
}
